import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotRefreshComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotRefresh',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FCC406",
    d: "M4.284 7.517c-.395.688-.011 1.525.73 1.806.743.28 1.56-.107 2.005-.764a6.127 6.127 0 0 1 10.14.001l-1.099.457a1 1 0 0 0-.08 1.809l3.964 2.076a1 1 0 0 0 1.42-.59L22.69 8.04a1 1 0 0 0-1.338-1.22l-1.503.624a9.005 9.005 0 0 0-6.197-4.306 9 9 0 0 0-9.368 4.38Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F5990D",
    d: "M3.391 17.589a1 1 0 0 1-1.346-1.212l1.3-4.282a1 1 0 0 1 1.415-.598l3.978 2.05a1 1 0 0 1-.07 1.81l-1.314.556a6.143 6.143 0 0 0 9.522-.066c.495-.615 1.336-.932 2.049-.593.712.339 1.024 1.2.576 1.85a9.001 9.001 0 0 1-14.856-.045l-1.254.53Z"
  }));
};
SpotRefreshComponent.displayName = 'SpotRefresh';
export var SpotRefresh = withProvisionalOverrideFromContext(SpotRefreshComponent);
//# sourceMappingURL=index.js.map